import axios from "axios";
import Config from "../config";

const updateNotification = data => {
    return axios({
        method: "post",
        url: (Config.url || '') + "/api/notification/update",
        data
    });
};

export default updateNotification;
